<template>
  <div class="detailed-location" v-if="content">
    <div class="detailed-location-container">
      <div class="detailed-location__title">Расположение на этаже</div>
      <div class="detailed-location__image">
        <img :src="content.locationImageFirst" alt="">
      </div>
      <a v-if="content.linkToPDF" :href="content.linkToPDF" class="detailed-location__link" target="_blanc">Скачать план пентхауса</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailedLocation',
  props: {
    content: Object
  }
}
</script>

<style scoped lang="stylus">
@import '../styles/tools'

.detailed-location
  display flex
  align-items center
  justify-content center

  &-container
    width-between-property 'max-width' 1000 150 1920 250 true true

    @media (max-width 600px)
      width 100%
      width-between-property 'max-width' 320 200 600 300 true false

    @media (max-width 1000px) and (min-width 600px)
      max-width 300px
      width 100%

  &__title
    font-family 'Asket Extended'
    font-size 14px
    width-between-property 'font-size' 1000 8 1920 14 true true
    color #fff
    text-transform uppercase
    margin-bottom 25px

    @media (max-width 1000px)
      width-between-property 'font-size' 320 10 1000 14 true false

  &__image
    margin-bottom 50px

    & img
      max-width 100%

  &__link
    font-family 'Asket Extended'
    width-between-property 'font-size' 1000 8 1920 14 true true
    color #fff
    text-transform uppercase 
    text-decoration underline

    @media (max-width 1000px)
      width-between-property 'font-size' 320 7 1000 14 true false


</style>